var map = {
	"./components/ContainerPets/CardPet/i18n.ts": 45,
	"./components/ContainerPets/i18n.ts": 46,
	"./components/Menu/i18n.ts": 47,
	"./components/Nav/i18n.ts": 48,
	"./pages/ChooseProfile/ProfileRoleContainer/i18n.ts": 49,
	"./pages/ChooseProfile/i18n.ts": 50,
	"./pages/Login/i18n.ts": 51,
	"./pages/PreLogin/i18n.ts": 52,
	"./pages/Register/i18n.ts": 53,
	"./pages/Splash/i18n.ts": 54
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44;